import React, { useState } from 'react';
import CartModal from '../../app/shop/components/Tests/CartModal';
import useShopCart from '../../hooks/useShopCart';

interface ShopModalProps {
  isOpenCart: boolean;
  setIsOpenCart: React.Dispatch<React.SetStateAction<boolean>>;
}

const ShopModal: React.FC<ShopModalProps> = ({ isOpenCart, setIsOpenCart }) => {
  const [isLoadingCartMutation, updateIsLoadingCartMutation] = useState(false);

  const {
    totalPrice,
    isLoadingCartData,
    updateSelectedProducts,
    isLoadingRequests,
    cartProducts,
  } = useShopCart(() => updateIsLoadingCartMutation(false));

  return (
    <CartModal
      updateSelectedProducts={updateSelectedProducts}
      totalPrice={totalPrice}
      cartProducts={cartProducts}
      isLoadingCartData={isLoadingCartData}
      isLoadingCartMutation={isLoadingCartMutation}
      updateIsLoadingCartMutation={updateIsLoadingCartMutation}
      isOpen={isOpenCart}
      onClose={() => setIsOpenCart(false)}
      isLoadingRequests={isLoadingRequests}
    />
  );
};

export default ShopModal;
